/** @format */

import {XAxisDataList} from 'components/charts/multiline-chart/model/xAxis';

const LABEL_SHIFT_LONG = 8; // Shift for labels with length > 1
const LABEL_SHIFT_SHORT = 4; // Shift for labels with length <= 1
const LINE_COORDINATE_Y = 27;
const TEXT_COORDINATE_Y = 28;
const RECT_SHIFT_X = 20;
const RECT_SHIFT_Y = 13;

interface Props {
  formattedGraphicalItems?: {
    props: {
      points: {
        payload: {name: string};
        x: number;
        y: number;
      }[];
    };
  }[];
  xAxisDataList: XAxisDataList;
  lineHeight: number;
}

const TodayMarker = (props: Props) => {
  const {formattedGraphicalItems, xAxisDataList, lineHeight} = props as Props;
  const keys = Object.keys(xAxisDataList);
  const todayKey = keys.find(key => xAxisDataList[key].todayLabel);

  if (!todayKey) {
    return null;
  }

  const todayGraphical = formattedGraphicalItems
    ? formattedGraphicalItems[0]?.props?.points?.find(item => item.payload.name === todayKey)
    : undefined;

  const label = xAxisDataList[todayKey].todayLabel;

  if (!todayGraphical || !label) {
    return null;
  }

  const labelShift = label.length > 1 ? LABEL_SHIFT_LONG : LABEL_SHIFT_SHORT;

  return (
    <g id='today'>
      <line
        x1={todayGraphical.x}
        y1={LINE_COORDINATE_Y}
        x2={todayGraphical.x}
        y2={lineHeight}
        stroke='#5D82CF'
        strokeWidth='2'
      />
      <rect
        x={todayGraphical.x - RECT_SHIFT_X}
        y={RECT_SHIFT_Y}
        width='40'
        height='20'
        rx='7'
        ry='7'
        fill='#5D82CF'
      />
      <text x={todayGraphical.x - labelShift} y={TEXT_COORDINATE_Y} fill={'#FAFBFE'} fontSize={14}>
        {label}
      </text>
    </g>
  );
};

export {TodayMarker};
